import { AnchorLink } from 'components/anchorLink';
import { IppicaTableRowMainInfoContent } from './ippicaTableRowMainInfoContent';
import { selectIppicaTodayDictionary } from 'features/ippica/selectors';
import styles from './IppicaTableRowMainInfo.module.scss';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaTableRowMainInfoProps = {
  keyAvvenimento: string;
  containerClassName?: string;
};

export const IppicaTableRowMainInfo = ({ keyAvvenimento, containerClassName }: IppicaTableRowMainInfoProps) => {
  const { isMobile } = useWindowSize();
  const ippicaToday = useSelector(selectIppicaTodayDictionary(keyAvvenimento))!;

  return (
    <>
      {isMobile ? (
        <AnchorLink
          href={`/ippica/${ippicaToday.codiceProgramma}-${ippicaToday.numeroAvvenimento}`}
          className={`${styles.container} ${containerClassName ? containerClassName : ''}`}
        >
          <IppicaTableRowMainInfoContent
            descrizioneRiunione={ippicaToday?.descrizioneRiunione!}
            tipoGara={ippicaToday?.tipoGara!}
          />
        </AnchorLink>
      ) : (
        <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
          <IppicaTableRowMainInfoContent
            href={`/ippica/${ippicaToday.codiceProgramma}-${ippicaToday.numeroAvvenimento}`}
            descrizioneRiunione={ippicaToday?.descrizioneRiunione!}
            tipoGara={ippicaToday?.tipoGara!}
          />
        </div>
      )}
    </>
  );
};
